{
  "CUSTOM_ROLE": {
    "HEADER": "Custom Roles",
    "LEARN_MORE": "Learn more about custom roles",
    "DESCRIPTION": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
    "HEADER_BTN_TXT": "Add custom role",
    "LOADING": "Fetching custom roles...",
    "SEARCH_404": "Det finnes ingen elementer som samsvarer med denne spørringen.",
    "PAYWALL": {
      "TITLE": "Upgrade to create custom roles",
      "AVAILABLE_ON": "The custom role feature is only available in the Business and Enterprise plans.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to advanced features like team management, automations, custom attributes, and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "The custom role feature is only available in the paid plans.",
      "UPGRADE_PROMPT": "Upgrade to a paid plan to access advanced features like audit logs, agent capacity, and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "LIST": {
      "404": "There are no custom roles available in this account.",
      "TITLE": "Manage custom roles",
      "DESC": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
      "TABLE_HEADER": {
        "NAME": "Navn",
        "DESCRIPTION": "Beskrivelse",
        "PERMISSIONS": "Permissions",
        "USAGE_COUNT": "Brukes av",
        "ACTIONS": "Handlinger"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Manage all conversations",
      "CONVERSATION_UNASSIGNED_MANAGE": "Manage unassigned conversations and those assigned to them",
      "CONVERSATION_PARTICIPATING_MANAGE": "Manage participating conversations and those assigned to them",
      "CONTACT_MANAGE": "Manage contacts",
      "ACCESS_ALL_REPORTS": "Vis alle rapporter",
      "KNOWLEDGE_BASE_MANAGE": "Manage knowledge base",
      "DATA_ASSISTANT_MANAGE": "Administrer dataassistent",
      "CALL_RECORDING_ACCESS": "Tilgang til alle samtaleopptak"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Navn",
        "PLACEHOLDER": "Please enter a name.",
        "ERROR": "Name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Beskrivelse",
        "PLACEHOLDER": "Please enter a description.",
        "ERROR": "Description is required."
      },
      "PERMISSIONS": {
        "LABEL": "Permissions",
        "ERROR": "Permissions are required."
      },
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      }
    },
    "ADD": {
      "TITLE": "Add custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Send",
      "API": {
        "SUCCESS_MESSAGE": "Custom role added successfully."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Rediger",
      "TITLE": "Edit custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Oppdater",
      "API": {
        "SUCCESS_MESSAGE": "Custom role updated successfully."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Slett",
      "API": {
        "SUCCESS_MESSAGE": "Custom role deleted successfully.",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      },
      "CONFIRM": {
        "TITLE": "Confirm deletion",
        "MESSAGE": "Er du sikker på at du vil slette ",
        "YES": "Ja, slett ",
        "NO": "Nei, behold "
      }
    }
  }
}
